import billing from './billing';
import content from './content';
import dashboard from './dashboard';
import management from './management';
import system from './system';
import setting from './setting';
import type { NavItemType } from '../types/menu';

const menuItems: { items: NavItemType[] } = {
  items: [dashboard, management, billing, content,system,setting],
};

export default menuItems;
